{{ cellDisplay$ | async }} <ng-container *ngIf="countdown$ | async as countdown">({{ countdown }})</ng-container>
